import React, { useEffect, useState } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useCurtain } from '../app/hooks'
import { Fade } from '@material-ui/core'

export const CurtainSkip = () => {
  const { skipCurtain, setSkipCurtain } = useCurtain()
  const [show, setShow] = useState(false)

  const onDontShowToggle = (e) => {
    setSkipCurtain(e.target.checked)
  }

  useEffect(() => {
		setTimeout(() =>
			setShow(true)
		, 300)
	}, [])

	return (
    <Fade
      in={show}
      timeout={1000}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={skipCurtain}
            onChange={onDontShowToggle}
            name="seda-opportunity-disable-curtain"
            color="default"
          />
        }
        label="Skip this next time"
      />
    </Fade>
	)
}